class StickyFooter extends HTMLElement {
  constructor() {
    "use strict";
    super();

    this.el = this;
    this.chatIcon = null;
    this.cookieIcon = null;
    this.shouldRemainHidden = false;
    this.hasScrolledPast = false; // Add this flag
  }

  connectedCallback() {
    // Force hide initially
    this.hideFooter();
    
    // Wait for page load and any dynamic content
    window.addEventListener('load', () => {
      setTimeout(() => {
        this.initializeFooter();
      }, 100);
    });

    // If already loaded, initialize directly
    if (document.readyState === 'complete') {
      setTimeout(() => {
        this.initializeFooter();
      }, 100);
    }
  }

  initializeFooter() {
    const elToWatch = document.querySelector('.product-single__form');
    if (!elToWatch) return;

    // Always start hidden
    this.hideFooter();
    this.lastScrollY = window.scrollY; // Track scroll position

    // Set up intersection observer for scroll events
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      const currentScrollY = window.scrollY;
      const isScrollingDown = currentScrollY > this.lastScrollY;
      
      if (!entry.isIntersecting && isScrollingDown) {
        console.log('Scrolled down past element');
        this.hasScrolledPast = true;
        this.showFooter();
      } else {
        this.hideFooter();
      }
      
      this.lastScrollY = currentScrollY;
    });

    observer.observe(elToWatch);

    // Rest of your existing setup
    document.addEventListener('product:added', () => {
      this.hideFooter();
      this.hasScrolledPast = false;
    });
    
    this.observeIcons();
  }

  toggleFooterVisibility(entries) {
    if (this.shouldRemainHidden) return;

    const entry = entries[0];
    this.hasScrolledPast = !entry.isIntersecting;

    // Debugging logs
    console.log('IntersectionObserver callback triggered.');
    console.log('Element is intersecting:', entry.isIntersecting);
    console.log('Has scrolled past:', this.hasScrolledPast);

    if (this.hasScrolledPast) {
      this.showFooter();
    } else {
      this.hideFooter();
    }
  }

  showFooter() {
    this.el.classList.add('--visible');
    this.adjustIconPositions();
    console.log('Footer shown.');
  }

  hideFooter() {
    this.el.classList.remove('--visible');
    this.resetIconPositions();
    console.log('Footer hidden.');
  }

  observeIcons() {
    const iconObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.id === 'ShopifyChat') {
              this.chatIcon = node;
              this.adjustIconPositions();
              console.log('Chat icon added.');
            }
            if (node.id === 'cookie-information-template-wrapper') {
              this.cookieIcon = node.querySelector('#Coi-Renew');
              this.adjustIconPositions();
              console.log('Cookie icon added.');
            }
          });
        }
      });
    });

    iconObserver.observe(document.body, { childList: true, subtree: true });
    console.log('Icon MutationObserver initialized.');
  }

  adjustIconPositions() {
    const bottomValue = window.matchMedia('(max-width: 768px)').matches ? '126px' : '60px';
    if (this.chatIcon) {
      this.chatIcon.style.bottom = bottomValue;
      this.chatIcon.style.transition = 'all 0.3s ease';
    }
    if (this.cookieIcon) {
      this.cookieIcon.style.bottom = bottomValue;
    }
    console.log(`Icon positions adjusted to ${bottomValue}.`);
  }

  resetIconPositions() {
    if (this.chatIcon) {
      this.chatIcon.style.bottom = '16px';
    }
    if (this.cookieIcon) {
      this.cookieIcon.style.bottom = '0';
    }
    console.log('Icon positions reset.');
  }

  updatePrice(variant) {
    const isWholesale = document.body.dataset.customerType === 'wholesale';
    // ... rest of code
  }
}

if (!customElements.get("sticky-footer")) {
  customElements.define("sticky-footer", StickyFooter);
}